import React from 'react';
import PropTypes from 'prop-types';
import { Row, Typography } from 'antd';
import './index.css';
import { HeaderErrorIcon } from '../../../components/common/CustomIcon';

const { Text } = Typography;

const SectionTitle = (props) => {
  return (
    <Row type="flex" align="middle" style={props.style ? props.style : { marginBottom: '24px' }}>
      <Text className={props.error ? 'pretest-section-title pretest-section-title-error' : 'pretest-section-title'}>{props.title}</Text>
      {props.error && (
        <Row type="flex" align="middle">
          <div style={{ marginLeft: '15px' }}><HeaderErrorIcon /></div>
          <div style={{ marginLeft: '7px' }}><Text className="pretest-section-error">Required</Text></div>
        </Row>
      )}
    </Row>
  );
};

SectionTitle.propTypes = {
  error: PropTypes.bool,
  title: PropTypes.object,
  style: PropTypes.object
};

export default SectionTitle;
